import { Box, BoxProps, ColorOptions, Form, TextInputNewProps } from '@jfs/ui-new'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.min.css'
import { SearchDataProps } from '.'
import { TextInputNew } from '../AdminInputs'
import { Dropdown } from '../Dropdown'
import { DropdownOptimised } from '../DropdownNew'
import { DropdownTypes } from '../DropdownNew/types'
import { GradientButton } from '../GradientButton'
import { CustomDatePickerInput } from '../NewTable/TableDatePicker'

interface SearchFilterProps {
  searchData: SearchDataProps[][]
  onSearchClick: any
  isLoading: boolean
  formRef: any
}

const handleSubmit = ({ defaultActionButtonOnSubmit, title = '', isLoading }: any) => {
  return (
    <Box marginTop={8} pb={8} alignItems={'center'}>
      <GradientButton
        title={title}
        onPress={defaultActionButtonOnSubmit}
        width={160}
        height={38}
        icon="SEARCH"
        borderRadius={4}
        isLoading={isLoading}
      />
    </Box>
  )
}

export const SearchFilter = ({ searchData, onSearchClick, isLoading, formRef }: SearchFilterProps) => {
  if (searchData?.length === 0) {
    return null
  }
  return (
    <Form
      ref={formRef}
      formData={getFormdata(searchData, onSearchClick)}
      container={FormBox}
      actionButtons={(props: any) => {
        return handleSubmit({
          ...props,
          title: ' Search',
          isLoading,
        })
      }}
    />
  )
}
const FormBox = ({ children }: any) => {
  return (
    <Box flexDirection={'column'} pv={16} ph={16}>
      {children}
    </Box>
  )
}

const searchDropDownProps = {
  labelDescription: 'By Procsessing Entity',
  singleSelection: true,
  componentType: 'dropdown',
  data: [],
  showSearch: true,
  maxHeight: 400,
  type: DropdownTypes.SELECTABLE_HIGHLIGHT,
}

const getFormdata = (searchFilters: SearchDataProps[][], onSearchClick: any): Array<any> => {
  return [
    {
      horizontalSpacing: 0,
      verticalSpacing: 4,
      horizontalFlex: 1,
      formItems: searchFilters.map((searchFiltersSubArray) => {
        return {
          horizontalComps: searchFiltersSubArray.map((searchFilter) => {
            const componentMap = {
              dropdownWithSearch: {
                fieldName: searchFilter.key,
                placeholder: searchFilter.placeHolder,
                ComponentName: DropdownOptimised,
                showSearch: true,
                maxHeight: 400,
                type: DropdownTypes.SELECTABLE_HIGHLIGHT,
                label: searchFilter.placeHolder,
                data: searchFilter.data,
                labelStyle: { color: 'BRAND_COLOR_GRAY_1', fontFamily: 'jiotype-medium' },
              },
              spacer: {
                fieldName: searchFilter.key,
                placeholder: searchFilter.placeHolder,
                ComponentName: Box,
              },
            }

            const defaultComp = {
              fieldName: searchFilter.key,
              placeholder: searchFilter.placeHolder,
              ComponentName:
                searchFilter.type === 'dropdown'
                  ? Dropdown
                  : searchFilter.type === 'date'
                  ? FilterDatePicker
                  : TextInputNew,
              maxLength: 50,
              title: 'Select',
              label: searchFilter.placeHolder,
              data: searchFilter.type === 'dropdown' ? [{ id: 0, value: undefined }, ...searchFilter.data] : undefined,
              ...(searchFilter.type !== 'dropdown' && styles.textinputStyle),
            }
            return componentMap[searchFilter.type] ?? defaultComp
          }),
        }
      }),
      onSubmit: async (values: any) => {
        onSearchClick(values)
      },
    },
  ]
}

const FilterDatePicker = ({
  value,
  fontSize,
  onChange,
  labelPaddingBottom = 12,
  labelFontFamily = 'jiotype-medium',
  labelFontSize = 12,
  labelColor = '#757575',
  dateFormat = 'dd-MM-yyyy',
  label,
  ...props
}: any) => {
  console.log('CustomDatePickerInput value=', value)
  if (value && !(value instanceof Date)) {
    value = parseDDMMYYYY(value)
    console.log('value=', value)
  } else {
    value = null
  }
  return (
    <DatePicker
      selected={value}
      onChange={(date) => onChange(date ? formattedDate(date) : '')}
      isClearable
      portalId="modal-root"
      dateFormat={dateFormat}
      placeholderText={label}
      {...props}
      fontSize={fontSize}
      maxDate={new Date()}
      customInput={
        <CustomDatePickerInput
          label={label}
          labelPaddingBottom={labelPaddingBottom}
          labelFontFamily={labelFontFamily}
          labelFontSize={labelFontSize}
          labelColor={labelColor}
        />
      }
    />
  )
}

const parseDDMMYYYY = (dateStr) => {
  const [day, month, year] = dateStr.split('-').map(Number)
  // Note: Months are zero-based in JavaScript Date object
  return new Date(year, month - 1, day)
}

const formattedDate = (date) => {
  let d = date.getDate().toString(),
    m = (date.getMonth() + 1).toString(),
    y = date.getFullYear().toString()
  let formatted = ''

  if (d.length === 1) {
    // pad to two digits if needed
    d = '0' + d
  }
  if (m.length === 1) {
    // pad to two digits if needed
    m = '0' + m
  }
  formatted = d + '-' + m + '-' + y
  // concatenate for output
  console.log('formatted=', formatted)
  return formatted
}

const styles = {
  container: {
    flexDirection: 'row',
  } as BoxProps,
  textinputStyle: {
    type: 'bodySecondary14',
    borderColor: '#d1d3e2' as ColorOptions,
    labelPaddingBottom: 8,
    borderRadius: 4,
    fontFamily: 'jiotype-medium',
    labelColor: '#757575' as ColorOptions,
    labelFontSize: 12,
    fontSize: 12,
    selectionColor: 'BLUE',
    paddingHorizontal: 8,
    color: '#212121' as ColorOptions,
    paddingVertical: 8,
    borderWidth: 1,
  } as TextInputNewProps,
}
